import { PivotTableProps } from 'components/pivot-table/PivotTable'

export type AtendimentoProfissional = {
  nomeProfissional: string
  tipoAtendimento: string
  unidadeSaude: string
  sexo: string
  duracao: number
}

export const AtendimentoProfissonalKeyMapping: PivotTableProps<AtendimentoProfissional>['keyMapping'] = new Map([
  ['nomeProfissional', { keyName: 'Profissionais' }],
  ['tipoAtendimento', { keyName: 'Tipo de Atendimento' }],
  ['unidadeSaude', { keyName: 'Unidade de Saúde' }],
  ['sexo', { keyName: 'Sexo' }],
  ['duracao', { keyName: 'Duração' }],
])

export const atendimentos: AtendimentoProfissional[] = [
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 0,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 3',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 4',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 5',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 1',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 1',
    sexo: 'MASCULINO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 1',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 2,
  },
  {
    nomeProfissional: 'PROFISSIONAL 2',
    tipoAtendimento: 'TIPO ATENDIMENTO 2',
    unidadeSaude: 'UNIDADE SAUDE 2',
    sexo: 'FEMININO',
    duracao: 5,
  },
]
